import { render, staticRenderFns } from "./BTab.vue?vue&type=template&id=8b7ecb68&scoped=true&"
import script from "./BTab.vue?vue&type=script&lang=js&"
export * from "./BTab.vue?vue&type=script&lang=js&"
import style0 from "./BTab.vue?vue&type=style&index=0&id=8b7ecb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7ecb68",
  null
  
)

export default component.exports